import { HTTPClient } from "../common/HTTPClient";

import { PaginationRequestParams } from "@/common/mixins/pagination";

export class ChannelClient {
  constructor(private httpClient: HTTPClient) {}

  public async getChannels(params: PaginationRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/channels",
      method: "GET",
      params
    });

    return data;
  }
}
